import { makeAutoObservable } from "mobx";
import { MatchUser } from "../models/api/MatchUser";
import { SwipeUser } from "../models/api/SwipeUser";
import { ProgStatus } from "../models/utilTypes";
import ApiService from "../services/ApiService";
import LocalStorageService from "../services/LocalStorageService";
import { rootStore } from "../StApp";
import { LikesComputer } from "./interfaces/LikesComputer";

export class MatchStore {

    potMatches: SwipeUser[] = []
    matches: MatchUser[] = []

    potMatchProg: ProgStatus = 'INIT'
    matchProg: ProgStatus = 'INIT'

    constructor() {
        makeAutoObservable(this)
    }

    loadPotMatches(silently = false) {

        if (!silently) {
            if (this.potMatchProg == 'SUCCESS')
                return
            this.potMatchProg = 'LOADING'
        }

        ApiService.getPotMatches({
            auth: rootStore.mainStore.token,
            data: {
                uid: rootStore.mainStore.uid!
            }
        }).then(resp => {
            if (!silently)
                this.potMatchProg = 'SUCCESS'
            this.potMatches = resp.data.users
        })
    }

    loadNewMatches(silently = false) {

        if (!silently) {
            if (this.matchProg == 'SUCCESS')
                return
            this.matchProg = 'LOADING'
        }

        ApiService.getNewMatches({
            uid: rootStore.mainStore.uid!
        }).then(resp => {
            if (!silently)
                this.matchProg = 'SUCCESS'
            this.matches = resp.data.users
        })
    }

    commitMatch(uid: string): boolean {

        if (rootStore.dateshipStore.likesLeft < 1)
            return false

        ApiService.registerMatch({
            auth: rootStore.mainStore.token,
            data: {
                uid: rootStore.mainStore.uid!,
                matchUid: uid
            }
        }).then(resp => {
            this.potMatches = this.potMatches.filter(item => item.uid !== uid)
            this.updateLeftLikes(resp.data.likeLeft)
        })

        this.updateLeftLikes(rootStore.dateshipStore.likesLeft - 1)

        return true


    }

    commitDump(uid: string) {

        ApiService.registerDump({
            auth: rootStore.mainStore.token,
            data: {
                uid: rootStore.mainStore.uid!,
                dumpUid: uid
            }
        }).then(resp => {
            this.potMatches = this.potMatches.filter(item => item.uid !== uid)
        })


    }

    private updateLeftLikes(value: number) {
        rootStore.dateshipStore.likesLeft = value
        LocalStorageService.updateStorage('likes_left', value)
    }


}